export default __webpack_public_path__ + "static/frame-2-hero-mobile-b79f27790775bc62c13b5652009ecc38.mp4";